import { SellContract, buildNewSellContract } from "@/models/SellContract";
import { map as Rmap } from "ramda";
import { AcSellContractResult } from "@/components/Autocomplete/ac-sell-contract";

interface SellContractState {
  sellContracts: SellContract[];
  sellContract: SellContract;
}

const state: SellContractState = {
  sellContracts: [],
  sellContract: buildNewSellContract(),
};

const mutations = {
  LOAD_SELL_CONTRACTS(state: SellContractState, payload: SellContract[]) {
    state.sellContracts = payload;
  },
  LOAD_SELL_CONTRACT(state: SellContractState, payload: SellContract) {
    state.sellContract = payload;
  },
};

const actions = {
  loadSellContracts(context: any, sellContracts: SellContract[]) {
    return new Promise((resolve, _reject) => {
      context.commit("LOAD_SELL_CONTRACTS", sellContracts);
      resolve(sellContracts);
    });
  },
  loadSellContract(context: any, sellContract: SellContract) {
    return new Promise((resolve, _reject) => {
      context.commit("LOAD_SELL_CONTRACT", sellContract);
      resolve(sellContract);
    });
  },
};

const getters = {
  sellContracts: (state: SellContractState) => {
    return state.sellContracts;
  },
  sellContract: (state: SellContractState) => {
    return state.sellContract;
  },
  sellContractsForAutocompleteId: (
    state: SellContractState,
  ): AcSellContractResult[] => {
    // map over the items and just return a label and an id
    return Rmap(sellContract => {
      return {
        id: sellContract.id,
        label: sellContract.label,
        clientLabel: sellContract.client_label,
        commodityLabel: sellContract.commodity_label,
        sellPrice: sellContract.sell_price,
        lotUnitLabel: sellContract.lot_unit_label,
        lotUnitId: sellContract.lot_unit_id,
      };
    }, state.sellContracts);
  },
};

const sellContractsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default sellContractsModule;
